import React, { Component } from 'react';
import * as Config from '../config/Config';
import * as Common from '../helpers/Common';

class EcProfile extends Component {
	constructor(props) {
		super(props);
        this.state={

        	profile : [],
        };

	}


	componentWillReceiveProps(next) {


	}

	getProfile(){
	    let pinno = Common.getUserData("pinNo", true);
	    let pinid = Common.getUserData("pinID", true);
	    let corp = Common.getUserData("corporateID", true);

		fetch(Config.domainUrl +"ecoach/ecoach-profile", {
	        method: "POST",
	        headers: {
	           'Accept': 'application/json',
	            'Content-Type': 'application/json',
                'Authorization':'Bearer ' +Common.getTokenData()
	          },
	        body: JSON.stringify({
			        pinno:pinno,
			        pinid:pinid,
			        corp_id:corp
                  })
	       }).then((response) => response.json()).then((responseJson) => {
	       	 	Common.reactLoader("hide");
	       	 	//alert(JSON.stringify(responseJson));
	       		 if (responseJson.status === 0) {
			        Common.message(responseJson.message, responseJson.errors, "error");
			      } else {
						this.setState({
							profile:responseJson.ecoach
						})

			      }
	       });
	}

    componentDidMount() {
    	this.getProfile();



    }



		render() {
			return (
				<section id="contentsection" className="contentarea">
					<div className="inner-title-bg journey-tit-bg">
						<h1><span><img src={process.env.PUBLIC_URL+"/images/login_history_img.png"} alt="" border="0" align="absmiddle" /></span>My E Coach<br /><span className="subtitle">My E Coach profile</span></h1>
					</div>
					<div className="main-inner">
						<div className="border-box">
							<section id="semana-scroll-inner" className="scroll1">
							    <section className="viewport">
							      <section className="overview">
							          <div className="inner-content">
										<div lass="contentbg" style={{clear:'both', paddingBottom:'50px'}}>
											<form name="thisForm" id="thisForm" >
												{(!this.state.profile)?<div className="ans-explanation" style={{textAlign:'center'}}>No E Coach assigned yet </div>
												:<div style={{paddingTop:'20px'}}>
											      <div className="ec-profile">
									                <div className="ec-profile-lft">
									                    <img src={Config.rootDomainUrl+"/admin/master_ecoach_photo/"+this.state.profile.photo} className="border" border="0" width="150" alt="Profile Image"  />
									                </div>
									                <div className="ec-profile-rgt">
									                   <table width="100%"  id="Detailview" cellPadding="5" cellSpacing="0"  border="0" >
									                   	<tbody>
															<tr>
																<td className="eprofile_left" width="120">First Name <span className="colon">:</span></td>
																<td  className="eprofile_right">{(this.state.profile.firstname==null)?'-':this.state.profile.firstname}</td>

															</tr>
															<tr>
																<td className="eprofile_left">Last Name <span className="colon">:</span></td>
																<td  className="eprofile_right">{(this.state.profile.lastname==null)?'-':this.state.profile.lastname}</td>
															</tr>
															{/* <tr>
																<td className="eprofile_left">Date of Birth <span className="colon">:</span></td>
																<td  className="eprofile_right">{(this.state.profile.mc_dob==null)?'-':this.state.profile.mc_dob}</td>
															</tr> */}
															<tr>
																<td className="eprofile_left">Gender <span className="colon">:</span></td>
																<td  className="eprofile_right">{(this.state.profile.gender==1)?'Male':'Female'}</td>
															</tr>
															<tr>
																<td className="eprofile_left">Qualification <span className="colon">:</span></td>
																<td  className="eprofile_right">{(this.state.profile.qualification==null)?'-':this.state.profile.qualification}</td>
															</tr>
															<tr>
																<td className="eprofile_left">E-Mail ID <span className="colon">:</span></td>
																<td  className="eprofile_right"><a href="javascript:void(0);" className="email">{this.state.profile.email}</a></td>
															</tr>
															<tr>
																<td className="eprofile_left">Mobile Number <span className="colon">:</span></td>
																<td  className="eprofile_right">{(this.state.profile.mobile==null)?'-':this.state.profile.mobile}</td>
															</tr>
															</tbody>
														</table>
									                </div>
											      </div>
												</div>}
											</form>
										</div>

							   		  </div>
							        </section>
							    </section>
							</section>
						</div>
					</div>
				</section>

			);
		}
}

export default EcProfile;



// WEBPACK FOOTER //
// ./src/lr_dlr_components/EcProfile.js